export default {
  noteList: state => state.globe.noteList,
  msgText: state => state.globe.msgText,
  asideWidth: state => state.globe.asideWidth,
  token: state => state.user.token,
  userInfo: state => state.user.userInfo,
}



// WEBPACK FOOTER //
// ./src/store/getter.js